import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RuleService {

  rule: string = environment.ruleWebApi;
  constructor(private http: SwHttpClientService) { }

  //#region  实体表 以及实体属性
  /**
   * 实体表 分页查询
   * @param params  参数
   */
  queryPageListEntity(params) {
    let path = this.rule + "entity/queryPageList"
    return this.http.Post(path, params)
  }

  /**
   * 实体表 修改接口 
   * @param params 
   */
  updateByIdEntity(params) {
    let path = this.rule + "entity/updateById"
    return this.http.Post(path, params)
  }
  

  queryListEntityAndItems(params){
    let path = this.rule + "entity/queryListAndItems"
    return this.http.Post(path, params)
  }
  /**
   * 实体表 保存
   * @param params 
   */
  save(params) {
    let path = this.rule + "entity/save"
    return this.http.Post(path, params)
  }

  /**
   * 删除实体表
   * @param param 
   */
  deleteBatch(param){
    let params= { delIds: param }; 
    let path = this.rule + "entity/deleteBatch"
    return this.http.Post(path, params)
  }
  /**
   * 通过主键去查model 
   * @param id  表单主键
   */
  queryEntityModel(id:string){
    let Params = { ids: [id] }
    let path = this.rule + "entity/queryById"
    return this.http.Post(path, Params)
  }

    /**
   * 通过实体表的主键与查找实体表列
   * @param id  表单主键
   */
  queryEntityItem(params){
    let path = this.rule + "entityItem/queryPageList"
    return this.http.Post(path, params)
  }


  /**
   * 保存实体类 列数据
   * @param param 
   */
  saveItem(param){
    let path = this.rule + "entityItem/save"
    return this.http.Post(path, param)
  }

  /**
   * 修改实体类 列数据
   * @param param 
   */
  updateEntityItem(param){
    let path = this.rule + "entityItem/updateById"
    return this.http.Post(path, param)
  }

  /**
   * 删除实体类 列数据
   * @param param 
   */
  deleteBatchItem(param){
    let params= { delIds: param }; 
    let path = this.rule + "entityItem/deleteBatch"
    return this.http.Post(path, params)
  }

    /**
   * 删除实体类 列数据
   * @param param 
   */
  entitySceneSaveOrDelete(params){
    let path = this.rule + "entityScene/saveOrDelete"
    return this.http.Post(path, params)
  }

  //#endregion
 
  //#region  规则配置
    /**
   * 查询配置文件
   * @param param 
   */
  queryPageListProperty(param){
    let path = this.rule + "property/queryPageList"
    return this.http.Post(path, param)
  }

  /**
   * 查询配置文件关联
   * @param param 
   */
  queryPageListRuleProperty(param){
    let path = this.rule + "ruleProperty/queryByFk"
    return this.http.Post(path, param)
  }
  
  saveOrDelRuleProperty(param){
    let path = this.rule + "ruleProperty/saveOrDelete"
    return this.http.Post(path, param)
  }

  //#endregion

  //#region  规则场景

  /**
   * 查询分页数据
   * @param param 
   */
  queryPageListScene(param){
    let path = this.rule + "scene/queryPageList"
    return this.http.Post(path, param)
  }

  /**
   * 修改规则场景
   * @param param 
   */
  updateByIdScene(param){
    let path = this.rule + "scene/updateById"
    return this.http.Post(path, param)
  }

  /**
   * 删除规则场景表
   * @param param 
   */
  deleteBatchScene(param){
    let params= { delIds: param }; 
    let path = this.rule + "scene/deleteBatch"
    return this.http.Post(path, params)
  }

  /**
   * 保存场景
   * @param param 
   */
  saveScene(param){
    let path = this.rule + "scene/save"
    return this.http.Post(path, param)
  }

    /**
   * 通过主键去查model 
   * @param id  表单主键
   */
  querySceneModel(id:string){
    let Params = { ids: [id] }
    let path = this.rule + "scene/queryById"
    return this.http.Post(path, Params)
  }

  /**
   * 查询场景和实体的关联数据
   */
  queryByFkEntityScene(param){
    let path = this.rule + "entityScene/queryByFk"
    return this.http.Post(path, param)
  }
  //#endregion

  //#region 规则详情

  queryPageListRule(param){
    let path = this.rule + "rule/queryPageList"
    return this.http.Post(path, param)
  }

  queryPageWithoutSceneId(param){
    let path = this.rule + "rule/queryListWithoutSceneId"
    return this.http.Post(path, param)
  }

  /**
   * 修改规则
   * @param param 
   */
  updateByIdRule(param){
    let path = this.rule + "rule/updateById"
    return this.http.Post(path, param)
  }

  /**
   * 删除规则
   * @param param 
   */
  deleteBatchRule(param){
    let params= { delIds: param }; 
    let path = this.rule + "rule/deleteBatch"
    return this.http.Post(path, params)
  }

  /**
   * 保存规则
   * @param param 
   */
  saveRule(param){
    let path = this.rule + "rule/save"
    return this.http.Post(path, param)
  }

    /**
   * 通过主键去查model 
   * @param id  表单主键
   */
  queryRuleModel(id:string){
    let Params = { ids: [id] }
    let path = this.rule + "rule/queryById"
    return this.http.Post(path, Params)
  }


  /**
   * 查询关联规则和行为
   * @param id  表单主键
   */
  queryRuleActionByFk(param){
    let path = this.rule + "ruleAction/queryByFk"
    return this.http.Post(path, param)
  }

    /**
   * 查询关联规则和行为
   * @param id  表单主键
   */
  SaveOrDeleteRuleAction(param){
    let path = this.rule + "ruleAction/saveOrDelete"
    return this.http.Post(path, param)
  }
  //#endregion

  //#region  规则表达式

  /**
   * 查询表达式分页
   * @param params 
   */
  queryPageListCondition(params){
    let path = this.rule + "condition/queryPageList"
    return this.http.Post(path, params)
  }

  /**
   * 保存表达式
   * @param params 
   */
  saveCondition(params){
    let path = this.rule + "condition/save"
    return this.http.Post(path, params)
  }

  /**
   * 修改表达式
   * @param params 
   */
  updateByIdCondition(params){
    let path = this.rule + "condition/updateById"
    return this.http.Post(path, params)
  }

  /**
   * 删除表达式
   * @param param 
   */
  deleteBatchCondition(param){
    let params= { delIds: param }; 
    let path = this.rule + "condition/deleteBatch"
    return this.http.Post(path, params)
  }


     /**
   * 通过主键去查model 
   * @param id  表单主键
   */
  queryConditionModel(id:string){
    let Params = { ids: [id] }
    let path = this.rule + "condition/queryById"
    return this.http.Post(path, Params)
  }
  //#endregion

  //#region   规则行为
    queryPageListAction(params) {
      let path = this.rule + "action/queryPageList"
      return this.http.Post(path, params)
    }
    
    queryByFkRuleAction(params){
      let path = this.rule + "ruleAction/queryByFk"
      return this.http.Post(path, params)
    }
  /**
   * 行为表 修改接口 
   * @param params 
   */
  updateByIdAction(params) {
    let path = this.rule + "action/updateById"
    return this.http.Post(path, params)
  }
  

  /**
   * 行为表 保存
   * @param params 
   */
  saveAction(params) {
    let path = this.rule + "action/save"
    return this.http.Post(path, params)
  }

  /**
   * 删除行为表
   * @param param 
   */
  deleteBatchAction(param){
    let params= { delIds: param }; 
    let path = this.rule + "action/deleteBatch"
    return this.http.Post(path, params)
  }
  /**
   * 通过主键去查model 
   * @param id  表单主键
   */
  queryActionModel(id:string){
    let Params = { ids: [id] }
    let path = this.rule + "action/queryById"
    return this.http.Post(path, Params)
  }

 
  //#endregion

  //#region  规则行为参数 

  queryPageListActionParam(params) {
    let path = this.rule + "actionParam/queryPageList"
    return this.http.Post(path, params)
  }

  /**
   * 行为表 修改接口 
   * @param params 
   */
  updateByIdActionParam(params) {
    let path = this.rule + "actionParam/updateById"
    return this.http.Post(path, params)
  }
  

  /**
   * 行为表 保存
   * @param params 
   */
  saveActionParam(params) {
    let path = this.rule + "actionParam/save"
    return this.http.Post(path, params)
  }

  /**
   * 删除行为表
   * @param param 
   */
  deleteBatchActionParam(param){
    let params= { delIds: param }; 
    let path = this.rule + "actionParam/deleteBatch"
    return this.http.Post(path, params)
  }
  //#endregion


  //#region 规则行为值

  
  queryPageListActionValue(params) {
    let path = this.rule + "actionValue/queryPageList"
    return this.http.Post(path, params)
  }

  /**
   * 行为表 修改接口 
   * @param params 
   */
  updateByIdActionValue(params) {
    let path = this.rule + "actionValue/updateById"
    return this.http.Post(path, params)
  }
  

  /**
   * 行为值表 保存
   * @param params 
   */
  saveActionValue(params) {
    let path = this.rule + "actionValue/save"
    return this.http.Post(path, params)
  }

  /**
   * 删除行为值表
   * @param param 
   */
  deleteBatchActionValue(param){
    let params= { delIds: param }; 
    let path = this.rule + "actionValue/deleteBatch"
    return this.http.Post(path, params)
  }

    /**
   * 通过主键去查model 
   * @param id  表单主键
   */
  queryActionValueModel(id:string){
    let Params = { ids: [id] }
    let path = this.rule + "actionValue/queryById"
    return this.http.Post(path, Params)
  }
  //#endregion
}
